import { SparklesIcon } from 'lucide-react';

import { Icon, Wrapper } from './rewardo_ai.styles';

type RewardoAiProps = {
  size?: 'small' | 'medium' | 'large';
};

export default function RewardoAi({ size = 'medium' }: RewardoAiProps) {
  return (
    <Wrapper size={size}>
      <Icon>
        <SparklesIcon size={size === 'large' ? 16 : size === 'medium' ? 14 : 12} />
      </Icon>{' '}
      Rewardo AI
    </Wrapper>
  );
}
